/**
 * 配車計画 受注モーダル
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/unregistered_orders`

const allocation_unregistered_order = {
  namespaced: true,
  actions: {
    index ({ commit }, { target_date, keyword, order_number, request_number, deal_number, with_assigned, order_keyword, supplier_id, supplier_type }) {
      const params = { target_date: target_date, keyword: keyword, order_number: order_number, request_number: request_number, deal_number: deal_number, with_assigned: with_assigned, order_keyword: order_keyword, supplier_id: supplier_id, supplier_type: supplier_type }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
export default allocation_unregistered_order
